import {AuthoringGuideModelV1} from 'resources/GeneratedModels/AuthoringGuide/AuthoringGuideModel.v1';
import {extensions} from './authoringGuide.extensions';
import {validators} from './authoringGuide.validators';

AuthoringGuideModelV1.extend(extensions);
AuthoringGuideModelV1.addValidators(validators);

export {AuthoringGuideModelV1};
